import { useSmsSocket } from './useSmsSocket';

export function SmsSocketInit(): null {
  useSmsSocket();
  return null;
}
